import React from 'react';
import { DialogProps } from '@economic/taco';
import SignupModal from '../../components/SignupModal';
import SignupDialogNavigationContextProvider from '../../components/SignupModal/contexts/SignupDialogNavigationContextProvider';
import SignupDialogOnboardingContextProvider from '../../components/SignupModal/contexts/SignupDialogOnboardingContextProvider';

interface Props extends Partial<DialogProps> {
    refetchState?: () => void;
    inMarket?: boolean;
}

const SignupDialogProvider = ({ refetchState, inMarket, ...dialogProps }: Props) => {
    return (
        <SignupDialogNavigationContextProvider>
            <SignupDialogOnboardingContextProvider>
                <SignupModal refetchState={refetchState} inMarket={inMarket} {...dialogProps} />
            </SignupDialogOnboardingContextProvider>
        </SignupDialogNavigationContextProvider>
    );
};

export default SignupDialogProvider;
